module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1053.e34d2279.png";